import * as service from './base';

const base_endpoint = `/api/pages/`;

export async function all() {
    const url = base_endpoint;
    return await service.get(url);
}

export async function get(id) {
    const url = `${base_endpoint}${id}`
    return await service.get(url);
}

export async function post(data) {
    const url = base_endpoint;
    await service.post(url, data)
}

export async function patch(id, data) {
    const url = `${base_endpoint}${id}`
    await service.patch(url, data)
}

export async function del(id) {
    const url = `${base_endpoint}${id}`
    await service.del(url)
}